// extracted by mini-css-extract-plugin
export default {"background":"SwipeableArticleCard_background__oUcBg"};